import { render, staticRenderFns } from "./CommentsComponent.vue?vue&type=template&id=c3cb8e44"
import script from "./CommentsComponent.vue?vue&type=script&lang=ts"
export * from "./CommentsComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports